"use client";

import { c as _c } from "react/compiler-runtime";
import { UrqlProvider } from "@urql/next";
import { createClient } from "./client/client";
export function GraphQLProvider(t0) {
  const $ = _c(8);
  const {
    children,
    errorHandler,
    apiUrl,
    wsUrl
  } = t0;
  let t1;
  if ($[0] !== apiUrl || $[1] !== errorHandler || $[2] !== wsUrl) {
    t1 = createClient({
      errorHandler,
      apiUrl,
      wsUrl
    });
    $[0] = apiUrl;
    $[1] = errorHandler;
    $[2] = wsUrl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [client, ssr] = t1;
  let t2;
  if ($[4] !== children || $[5] !== client || $[6] !== ssr) {
    t2 = <UrqlProvider client={client} ssr={ssr}>{children}</UrqlProvider>;
    $[4] = children;
    $[5] = client;
    $[6] = ssr;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}